import { type ReactNode } from 'react';
import { LmsSkipped } from '@/icons/components/LmsSkipped';
import { AnswerIconO, AnswerIconX } from '@/shared/components/AnswerIcon';
import { useQuizTypeTranslation } from '@/shared/hooks/useQuizTypeTranslation';
import { type QuizType } from '@/types';
import { cn } from '@/utils';
export const QuizCardHeader = ({
  className,
  answerStatus = null,
  questionNumber,
  questionType,
  rightSlot
}: {
  className?: string;
  answerStatus?: 'correct' | 'incorrect' | 'unsolve' | null;
  questionNumber: string;
  questionType: QuizType;
  rightSlot?: ReactNode;
}) => {
  const translateQuizType = useQuizTypeTranslation(questionType);
  return <QuizCardHeaderBase className={cn('bg-alternative', answerStatus === 'correct' && 'bg-green-50', answerStatus === 'incorrect' && 'bg-red-50', answerStatus === 'unsolve' && 'bg-alternative', className)} leftSlot={(() => {
    switch (answerStatus) {
      case 'correct':
        return <AnswerIconO className="size-[24px]" />;
      case 'incorrect':
        return <AnswerIconX className="size-[24px]" />;
      case 'unsolve':
        return <LmsSkipped className="size-[24px]" />;
      case null:
      default:
        return null;
    }
  })()} title={questionNumber} subTitle={translateQuizType} rightSlot={rightSlot} data-sentry-element="QuizCardHeaderBase" data-sentry-component="QuizCardHeader" data-sentry-source-file="QuizCardHeader.tsx" />;
};
export const QUIZ_CARD_HEADER_CLASSNAME = 'QUIZ_CARD_HEADER_CLASSNAME';
export const QuizCardHeaderBase = ({
  className,
  title,
  subTitle,
  leftSlot,
  rightSlot
}: {
  className?: string;
  title: string;
  subTitle: string;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
}) => {
  return <div className={cn(QUIZ_CARD_HEADER_CLASSNAME, 'h-[54px] px-[24px] flex items-center justify-between', className)} data-sentry-component="QuizCardHeaderBase" data-sentry-source-file="QuizCardHeader.tsx">
      <div className="flex flex-row items-center gap-xs">
        {leftSlot}
        <h2 className="text-heading-sm-bold text-default">{title}</h2>
        <h3 className="text-body-lg-semibold text-alternative">{subTitle}</h3>
      </div>
      {rightSlot}
    </div>;
};